import { minutesToHoursAndMinutes } from "../minutesToHoursAndMinutes/minutesToHoursAndMinutes";
import { ServiceDuration } from "../../AppDataProvider/types";
import { TFunction } from "react-i18next";

/**
 * Converts a duration (or list of durations) into a human-readable
 * display string.
 * @param duration either a list of durations or a single duration to be formatted
 * @param t a translation function from i18next
 * @returns a translated human-readable string showing the duration time
 */
export function getDurationDisplay(
  duration: ServiceDuration | ServiceDuration[],
  t: TFunction,
) {
  // If we've passed a list of durations, get the shortest duration's minutes
  const minutes =
    "length" in duration
      ? Math.min(...duration.map((d) => d.minutes))
      : duration.minutes;

  let result: string;
  /**
   * We only want to represent a duration in days if it an exact
   * number of days, otherwise represent in hours/minutes.
   */
  if (minutes >= 1440 && minutes % 1440 === 0) {
    const days = Math.floor(minutes / 1440);
    result = t("countDays", { count: days });
  } else {
    const { hours, remainingMinutes } = minutesToHoursAndMinutes(minutes);

    const hoursDisplay = t("countHours", { count: hours });
    const minutesDisplay = t("countMinutes", { count: remainingMinutes });
    if (hours && remainingMinutes) {
      result = `${hoursDisplay} ${minutesDisplay}`;
    } else if (hours) {
      result = hoursDisplay;
    } else {
      result = minutesDisplay;
    }
  }

  if ("length" in duration && duration.length > 1)
    result = t("fromValue", { value: result });

  return result;
}

export default getDurationDisplay;
